/**
 * Separate set of FormControl from top-level that isn't tied to PDS
 */
import FormControl from 'shared/components/FormControl/FormControl';
import UnwrappedInput from 'shared/components/Input';

import UnwrappedPhoneInput from 'inquiry/components/PhoneInput';
import UnwrappedTextArea from 'inquiry/components/TextArea';

export default FormControl;

export const Input = FormControl<React.InputHTMLAttributes<{}>>(UnwrappedInput);
export const TextArea = FormControl<React.InputHTMLAttributes<{}>>(UnwrappedTextArea);
export const PhoneInput = FormControl(UnwrappedPhoneInput);
